module.exports = {
  pathPrefix: "/", // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: "Seven Good Gifts", // Navigation and Site Title
  siteTitleAlt: "7GOODGIFTS.COM", // Alternative Site title for SEO
  siteTitleManifest: "7-good-gifts",
  siteUrl: "https://7goodgifts.com", // Domain of your site. No trailing slash!
  siteLanguage: "en", // Language Tag on <html> element
  siteHeadline: "Discover good gifts for friends and family.", // Headline for schema.org JSONLD
  siteBanner: "/social/logo.png", // Your image for og:image tag. You can find it in the /static folder
  favicon: "src/favicon.png", // Your image for favicons. You can find it in the /src folder
  siteDescription: "The best place to discover gift ideas for anyone fast.", // Your site description
  author: "7GG", // Author for schemaORGJSONLD
  siteLogo: "/social/logo.png", // Image for schemaORGJSONLD

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  // userTwitter: '@minimal', // Twitter Username - Optional
  // ogSiteName: 'minimal', // Facebook Site Name - Optional
  ogLanguage: "en_US", // Facebook Language
  googleAnalyticsID: "UA-137409833-2",

  // Manifest and Progress color
  // See: https://developers.google.com/web/fundamentals/web-app-manifest/
  themeColor: "#1C75BC",
  backgroundColor: "#F45625"
};
